<template>
   <div class="form-group">
      <label
         for="ip_email"
         :class="['label-overlay', { active: !isNotEmpty(form.email) }]"
         @click="switchLabel($event)"
      >
         Work Email
      </label>
      <input
         id="ip_email"
         v-model.trim="form.email"
         type="text"
         class="form-control"
         name="emailAddress"
         :class="[
            { 'is-invalid': isValidMail.inValidLength },
            { 'is-invalid': isValidMail.inValidAttampt },
            { 'is-valid': isValidMail.isValid },
         ]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateMailData();
            initiatedType();
         "
      />
      <div class="invalid-feedback">Please enter valid email.</div>
      <div class="valid-feedback">Sounds good.</div>
   </div>
</template>

<script>
import axios from 'axios';
import person from '../../../util/userData.js';

export default {
   name: 'EmailComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidMail: {
            inValidAttampt: false,
            inValidLength: false,
            isValid: false,
         },
         form: {
            email: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         this.form.email = this.person.profileData.email || '';
      }
      if (this.$route.query.email) {
         this.form.email = this.$route.query.email;
      }
   },
   methods: {
      validateMailData() {
         /* if (this.form.email.length !== 0) {
            this.validateMailDataOnline();
         } else {
            this.isValidMail = {
               inValidAttampt: this.$parent.attemptSubmit && this.isValidEmail,
               inValidLength: true,
               isValid: !this.isValidEmail,
            };
        } */
         this.isValidMail = {
            inValidAttampt: this.$parent.attemptSubmit && this.isValidEmail,
            inValidLength: this.form.email.length !== 0 && this.isValidEmail,
            isValid: !this.isValidEmail,
         };
      },
      reset() {
         this.isValidMail.inValidAttampt = false;
         this.isValidMail.inValidLength = false;
         this.isValidMail.isValid = false;
         this.form.email = '';
      },
      async validateMailDataOnline() {
         const API_PATH = `https://api.zerobounce.net/v2/validate?api_key=9e6617a779ad482282e51f775f750d8a&email=${this.form.email}&ip_address=`;
         /* const paramsData = {
            access_key: 'dd2017b4b2d14ac9aa6136c2ae85f83d',
            email: this.form.email,
         }; */
         await axios
            .get(API_PATH)
            .then(response => {
               const excludeDomains = ['ru', 'by', 'cn', 'edu'];
               if (
                  !response.data.smtp_provider ||
                  response.data.status === 'invalid' ||
                  excludeDomains.includes(response.data.domain.split('.').at(-1))
               ) {
                  // if(response.data.smtp_check === false || response.data.free === true)
                  this.isValidMail = {
                     inValidAttampt: true,
                     inValidLength: false,
                     isValid: false,
                  };
               } else {
                  this.isValidMail = {
                     inValidAttampt: this.$parent.attemptSubmit && this.isValidEmail,
                     inValidLength: this.form.email.length !== 0 && this.isValidEmail,
                     isValid: !this.isValidEmail,
                  };
               }
            })
            .catch(err => {
               // console.log(err)
            });
      },
      initiatedType() {
         if (this.form.email !== '') {
            this.userProfileTracker.information({ email: this.form.email });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;
            this.tracker(this.options.mixpanelEve, {
               ...(this.options.name && { Name: this.options.name }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
